import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import api from '../lib/api';

export const useCopyTradeStore = create(persist(
  (set, get) => ({
    configs: [],
    selectedConfig: null,
    isLoading: false,
    error: null,

    fetchConfigs: async () => {
      try {
        set({ isLoading: true, error: null });
        const response = await api.get('/copy-trade');
        set({ configs: response.data, isLoading: false });
      } catch (error) {
        set({ error: error.response?.data?.error || 'Failed to fetch configs', isLoading: false });
      }
    },

    createConfig: async (configData) => {
      try {
        set({ isLoading: true, error: null });
        const response = await api.post('/copy-trade', configData);
        set({
          configs: [...get().configs, response.data],
          isLoading: false
        });
        return { success: true, config: response.data };
      } catch (error) {
        set({ error: error.response?.data?.error || 'Failed to create config', isLoading: false });
        return { success: false, error: error.response?.data?.error };
      }
    },

    updateConfig: async (id, configData) => {
      try {
        set({ isLoading: true, error: null });
        const response = await api.put(`/copy-trade/${id}`, configData);
        set({
          configs: get().configs.map(c => c._id === id ? response.data : c),
          selectedConfig: get().selectedConfig?._id === id ? response.data : get().selectedConfig,
          isLoading: false
        });
        return { success: true, config: response.data };
      } catch (error) {
        set({ error: error.response?.data?.error || 'Failed to update config', isLoading: false });
        return { success: false, error: error.response?.data?.error };
      }
    },

    deleteConfig: async (id) => {
      try {
        set({ isLoading: true, error: null });
        await api.delete(`/copy-trade/${id}`);
        set({
          configs: get().configs.filter(c => c._id !== id),
          selectedConfig: get().selectedConfig?._id === id ? null : get().selectedConfig,
          isLoading: false
        });
        return { success: true };
      } catch (error) {
        set({ error: error.response?.data?.error || 'Failed to delete config', isLoading: false });
        return { success: false, error: error.response?.data?.error };
      }
    },

    toggleConfig: async (id) => {
      try {
        const response = await api.post(`/copy-trade/${id}/toggle`);
        set({
          configs: get().configs.map(c => c._id === id ? response.data : c),
          selectedConfig: get().selectedConfig?._id === id ? response.data : get().selectedConfig
        });
        return { success: true, config: response.data };
      } catch (error) {
        return { success: false, error: error.response?.data?.error };
      }
    },

    selectConfig: (config) => {
      set({ selectedConfig: config });
    },

    clearError: () => {
      set({ error: null });
    }
  }),
  {
    name: 'betmimic.copyTradeStore',
    partialize: (state) => ({
      configs: state.configs,
      selectedConfig: state.selectedConfig
    })
  }
));
